<template>
  <div v-if="address!=null">
    <div v-if="getAddressLine1()!=null"><span class="company-info">{{getAddressLine1()}}</span><br></div>
    <div v-if="getAddressLine2()!=null"><span class="company-info">{{getAddressLine2()}}</span><br></div>
    <div v-if="getAddressLine3()!=null"><span class="company-info">{{getAddressLine3()}}</span></div>
  </div>
</template>
<script>
import axios from "axios"
export default {
	name: 'AddressCard',
	props: {
    address : Object
	},
	data() {
		return {
		}
	},
	methods : {
    getAddressLine1(){
			if(this.address.street==null || this.address.street==''){
				return null
			}
			return this.address.street;
		},
		getAddressLine2(){
			var line = "";
			if(this.address.city!=null){
				line+=this.address.city;
			}

      const postalCode = _.get(this.address, 'postalCode') || _.get(this.address, 'postal_code');

			if(postalCode !=null && postalCode!=''){
				if(line!=''){
					line+=", " + postalCode;
				}else{ line = postalCode}
			}
			if(line==""){return null}
			return line;

		},
		getAddressLine3(){
      const otherState = _.get(this.address, 'otherState') || _.get(this.address, 'other_state');
			var line="";
			if(this.address.state!=null){
				line+=this.address.state.name;
			}else if(otherState !=null && otherState !=""){
				line+=otherState;
			}
			if(line==""){line=this.address.country.name}else{line+=", "+this.address.country.name}
			return line;
		}
	}
}
</script>
